import get from 'lodash/get';
import { CATEGORIE_LOCATION } from '@/configurations/recomConfig';

export function isLigneLocation(ligne) {
  const categorie = get(ligne, 'produit.supportCommercial.categorieVente');
  return categorie === CATEGORIE_LOCATION;
}
export function isLigneTlpe(ligne, societe) {
  return (societe && ligne.produitId === societe.produitIdDefautTlpe)
    || (ligne.produit && ligne.produit.produitDivers && ligne.produit.produitDivers.tlpe);
}
export function isLigneHonoraires(ligne, societe, strict = false) {
  if (strict) return societe && ligne.produitId === societe.produitIdHonoraire;
 return (societe && ligne.produitId === societe.produitIdHonoraire)
    || (ligne.produit && ligne.produit.produitDivers && ligne.produit.produitDivers.honoraire);
}
export function isLigneHonoraireFraisTraitement(ligne, societe) {
  return societe && ligne && ligne.produitId === societe.produitIdHonoraireFraisTraitement;
}
export function isLigneFraisTechnique(ligne, societe) {
  return societe && ligne && ligne.produitId === societe.produitIdDefautFraisTechnique;
}
